import Template from './SellerIdView.njk';
import $ from "jquery";
import Marionette from "backbone.marionette";
import Xola from "../../Xola";
import { Cookie } from "../../application/Cookie";
import "./SellerIdView.less";

export const SellerIdView = Marionette.View.extend({
  template: Template,
    className: "SellerIdView",
    events: {
        "click button.cancel": "onCancel",
        "submit form": "onSubmit"
    },

    onSubmit(event) {
        this.$el.find('input, button').prop("disabled", true);
        event.preventDefault();

        var fieldValues = this.getFieldValues();
        var seller = new Xola.Model.Seller({id: fieldValues.seller});
        seller.fetch({
            success: () => {
                this.trigger('seller.select', seller);
            },
            error: () => {
                this.showErrors();
                this.$el.find('input, button').prop("disabled", false);
            }
        });
    },

    onCancel() {
        Xola.logout();
        Cookie.setApiKey(null);

        this.trigger('seller.cancel');
    },

    getFieldValues() {
        var fieldValues = {};

        this.$el.find('input').each(function(i, el) {
            el = $(el);

            switch (el.attr('type')) {
                case 'checkbox':
                case 'radio':
                    fieldValues[el.attr('name')] = el.is(':checked');
                    break;

                default:
                    fieldValues[el.attr('name')] = el.val();
            }
        });

        return fieldValues;
    },

    showErrors() {
        this.$el.find(".form-group").addClass("has-error");
        this.$el.find("#form-seller-id").focus().select();
    },

    hideErrors() {
        this.$el.find(".form-group").removeClass("has-error");
    }
});


// WEBPACK FOOTER //
// ./src/js/view/pages/SellerIdView.js